document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll(".category-link").forEach((link) => {
    link.addEventListener("click", async function (e) {
      e.preventDefault(); // Prevent the default anchor behavior

      const templateContent = this.parentNode.querySelector(
        ".ob-size-guide-template",
      ).innerHTML;

      const tempDiv = document.createElement("div");
      tempDiv.innerHTML = templateContent;
      const images = Array.from(tempDiv.querySelectorAll("img"));
      await Promise.all(images.map((img) => enhanceImage(img)));

      const modal = document.getElementById("ob-template-sizeGuideModal");
      modal.querySelector(".ob-template-modal-body").innerHTML = tempDiv.innerHTML;
      modal.style.display = "block";
      modal.setAttribute("role", "dialog");
      modal.setAttribute("aria-modal", "true");
      modal.setAttribute("aria-label", "Size guide");

      window.__obSizeGuidePrevFocus = document.activeElement;

      const initialFocus =
        modal.querySelector(".ob-template-close-button") ||
        getFocusableElements(modal)[0] ||
        modal;
      initialFocus.focus();

      // Trap focus inside modal
      trapFocus(modal);

      // Initialize the size guide script for the new content
      initializeSizeGuideScript();
    });
  });

  const closeButton = document.querySelector(".ob-template-close-button");
  closeButton.addEventListener("click", function () {
    const modal = document.getElementById("ob-template-sizeGuideModal");
    modal.style.display = "none"; // Hide the modal
    modal.querySelector(".ob-template-modal-body").innerHTML = ""; // Clear the modal content
    if (
      window.__obSizeGuidePrevFocus &&
      typeof window.__obSizeGuidePrevFocus.focus === "function"
    ) {
      window.__obSizeGuidePrevFocus.focus();
    }
  });

  // Add a 'keydown' event listener to the close button
  closeButton.addEventListener("keydown", function (event) {
    // Check if the key pressed is "Enter"
    if (event.key === "Enter" || event.keyCode === 13) {
      const modal = document.getElementById("ob-template-sizeGuideModal");
      modal.style.display = "none"; // Hide the modal
      modal.querySelector(".ob-template-modal-body").innerHTML = ""; // Clear the modal content
    }
  });

  window.addEventListener("click", function (event) {
    const modal = document.getElementById("ob-template-sizeGuideModal");
    if (event.target === modal) {
      modal.style.display = "none";
      modal.querySelector(".ob-template-modal-body").innerHTML = ""; // Clear the modal content
    }
  });
});

function enhanceImage(img) {
  return new Promise((resolve) => {
    const src = img.getAttribute("src");
    if (!src) return resolve();

    img.setAttribute("loading", "lazy");

    const newImg = new Image();
    newImg.onload = () => {
      img.setAttribute("width", newImg.naturalWidth);
      img.setAttribute("height", newImg.naturalHeight);

      if (src.includes("cdn.shopify.com")) {
        const base = src.split("?")[0];
        img.setAttribute("srcset", [
          `${base}?width=${Math.round(newImg.naturalWidth / 2)} ${Math.round(newImg.naturalWidth / 2)}w`,
          `${base}?width=${newImg.naturalWidth} ${newImg.naturalWidth}w`,
          `${base}?width=${Math.round(newImg.naturalWidth * 1.5)} ${Math.round(newImg.naturalWidth * 1.5)}w`,
        ].join(", "));
        img.setAttribute("sizes", "(max-width: 768px) 100vw, 600px");
      }

      resolve();
    };
    newImg.onerror = resolve;
    newImg.src = src;
  });
}

function getFocusableElements(container) {
  const selector =
    "a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe";
  return Array.from(container.querySelectorAll(selector)).filter((el) => {
    if (
      el.hasAttribute("aria-hidden") &&
      el.getAttribute("aria-hidden") === "true"
    )
      return false;
    if (el.closest('[aria-hidden="true"], [hidden]')) return false;
    // filter out invisible
    const style = window.getComputedStyle(el);
    if (style.visibility === "hidden" || style.display === "none") return false;
    if (!el.offsetParent && el !== container) return false;
    return true;
  });
}

function trapFocus(element) {
  const onKeyDown = (event) => {
    if (event.key !== "Tab") return;
    const focusable = getFocusableElements(element);
    if (!focusable.length) return;
    const first = focusable[0];
    const last = focusable[focusable.length - 1];
    if (event.shiftKey) {
      if (
        document.activeElement === first ||
        !element.contains(document.activeElement)
      ) {
        event.preventDefault();
        last.focus();
      }
    } else {
      if (
        document.activeElement === last ||
        !element.contains(document.activeElement)
      ) {
        event.preventDefault();
        first.focus();
      }
    }
  };

  const onFocusIn = (event) => {
    if (!element.contains(event.target)) {
      const focusable = getFocusableElements(element);
      if (focusable.length) focusable[0].focus();
    }
  };

  element.__obTrapHandlers = { onKeyDown, onFocusIn };
  element.addEventListener("keydown", onKeyDown);
  document.addEventListener("focusin", onFocusIn);
}

function initializeSizeGuideScript() {
  const unitSelector = document.getElementById("unitSelector");
  if (unitSelector) {
    unitSelector.addEventListener("change", function () {
      var unit = this.value;
      document
        .getElementById("tableInches")
        .classList.toggle("hidden", unit !== "inches");
      document
        .getElementById("tableCm")
        .classList.toggle("hidden", unit !== "cm");
    });

    // Trigger the change event to set the default view
    var event = new Event("change");
    unitSelector.dispatchEvent(event);
  }
}
